import styled from "styled-components";

export const WarningContainer = styled.div`
  width: 100%;
  padding: 2rem;
  text-align: center;
`;

export const Warning = styled.p`
  font-size: 1.4rem;
  font-weight: 700;
  line-height: 1.6rem;
`;
